<template>
  <div id="AddresseeDetail">
    <el-row style="top: 5px">
      <el-col :span="22" :offset="1">
        <el-table
          :data="tableData"
          v-loading="pageLoading"
          style="width: 100%; margin-bottom: 75px"
        >
          <!-- 收件人 -->
          <el-table-column
            prop="recipientName"
            :label="$t('orderManagement.recipientName')"
            align="left"
            width="120px"
          >
          </el-table-column>
          <!-- 手机 -->
          <el-table-column
            prop="recipientTelephone"
            :label="$t('orderManagement.telephone')"
            align="center"
            width="110px"
          >
          </el-table-column>
          <!-- 邮箱 -->
          <el-table-column
            prop="recipientEmail"
            :label="$t('orderManagement.email')"
            align="left"
            min-width="150"
          >
          </el-table-column>
          <!-- 公司/机构 -->
          <el-table-column
            prop="existingCompany"
            :label="$t('orderManagement.company')"
            align="left"
            min-width="150"
          >
          </el-table-column>
          <!-- 国家 -->
          <el-table-column
            prop="country"
            :label="$t('orderManagement.country')"
            align="center"
            min-width="50"
          >
            <!-- 中国 -->
            <span>{{ $t("orderManagement.china") }}</span>
          </el-table-column>
          <!-- 配送地址 -->
          <el-table-column
            prop="courseName"
            :label="$t('orderManagement.courseName')"
            align="left"
            min-width="250"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  {{
                    stringIfNull(scope.row.province) +
                      stringIfNull(scope.row.city) +
                      stringIfNull(scope.row.area) +
                      stringIfNull(scope.row.detailedAddress)
                  }}
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <!-- 数量 -->
          <el-table-column
            prop="purchaseNumber"
            :label="$t('orderManagement.purchaseNumber1')"
            align="right"
            width="80"
          >
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row></el-row>
  </div>
</template>

<script>
export default {
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // 页面载入状态
      pageLoading: false,
      // 页面数据
      tableData: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    async init() {
      this.tableData = [];
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#AddresseeDetail")
      });
      let url = "/api/orderManagement/getAddresseeList";
      await this.$http
        .post(url, {
          orderId: this.$props.orderId
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.tableData = [];
            } else {
              // 渲染页面
              this.tableData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    stringIfNull(val) {
      if (val !== null) {
        return val;
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.blueDivider {
  display: inline-block;
}

.blueDivider >>> .el-divider--vertical {
  background-color: #00b0f0;
}

.foot-container {
  margin: 100px auto 0 auto;
  height: 26px;
  width: 50%;
  text-align: center;
}

/* p0402 */
/* email群模板 */
.el-button--p0402create:focus,
.el-button--p0402create {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

.el-button--p0402save:focus,
.el-button--p0402save {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 130px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

/* 返回 */
.el-button--p0402return {
  /* 999999 */
  background-color: #ffffff;
  /* 999999 */
  border-color: #d9d9d9;
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #000000;
  font-size: 13px;
  line-height: 18px;
}

.el-button--p0402add:focus,
.el-button--p0402add {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 14px;
  line-height: 24px;
  border-radius: 6px;
}

>>> .el-dialog__body {
  padding-top: 10px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding: 3px 30px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Asqms/views/OrderManagement/AddresseeDetail.vue